// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import Actions from "../../../../actions/contactSources";
import List from "./List";

class ContactSources extends Component {
  componentWillMount = () => {
    this.props.dispatch(Actions.fetchContactSources());
  };

  onDelete = ids => {
    ids.map(id => {
      this.props.dispatch(Actions.onDelete(id)).then(() => {
        this.props.dispatch(Actions.fetchContactSources());
      });
    });
  };

  onFetchContactSource = (id) => {
    this.props.dispatch(Actions.fetchContactSource(id));
  }

  onNew = () => {
    this.props.dispatch(Actions.onNew());
  }

  onChangePage = value => {
    this.props
      .dispatch(Actions.onChangePage(value))
      .then(() => this.props.dispatch(Actions.fetchContactSources()));
  };

  onSearch = e => {
    this.props
      .dispatch(Actions.onSearch(e.target.value))
      .then(() => this.props.dispatch(Actions.fetchContactSources()));
  };

  render() {
    const { isLoading, isModalVisible, contactSources, meta, fetchParams } = this.props;
    return (
      <List
        loading={isLoading}
        isModalVisible={isModalVisible}
        contactSources={contactSources}
        meta={meta}
        fetchParams={fetchParams}
        onDelete={this.onDelete}
        onSearch={this.onSearch}
        onChangePage={this.onChangePage}
        onFetchContactSource={this.onFetchContactSource}
        onNew={this.onNew}
      />
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.contactSources.isLoading,
  isModalVisible: state.contactSources.isModalVisible,
  contactSources: state.contactSources.contactSources,
  meta: state.contactSources.meta,
  fetchParams: state.contactSources.fetchParams
});

export default connect(mapStateToProps)(ContactSources);
